module.exports = __webpack_public_path__ + "img/change.5ba0ccb3.png";